import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import { generateGoogleMapsUrl } from "mt-shared/maps";
import InfoIcon from "./InfoIcon";

type MeetingPlaceGoogleMapsQuery = {
  url?: string | null;
  placeId?: string | null;
  geoLocation?: {
    lat: number;
    lng: number;
  } | null;
};

type MeetingPlaceInfoProps = {
  meetingPlaceName?: string | null;
  meetingPlaceGoogleMapsQuery?: MeetingPlaceGoogleMapsQuery | null;
};

export default function MeetingPlaceInfo({
  meetingPlaceName,
  meetingPlaceGoogleMapsQuery,
}: MeetingPlaceInfoProps) {
  if (!meetingPlaceName || !meetingPlaceGoogleMapsQuery) return null;

  const googleMapsUrl =
    meetingPlaceGoogleMapsQuery.url ||
    generateGoogleMapsUrl(meetingPlaceGoogleMapsQuery);

  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start">
      <InfoIcon>
        <PlaceOutlinedIcon sx={{ fontSize: 18 }} />
      </InfoIcon>
      <Box>
        <Typography
          sx={{
            color: "#a8afbc",
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
            textTransform: "uppercase",
          }}
        >
          Meeting Place
        </Typography>
        <MuiLink
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{
            color: "#5f6b7a",
            display: "block",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.25,
          }}
        >
          {meetingPlaceName}
        </MuiLink>
      </Box>
    </Stack>
  );
}
